export default __webpack_public_path__ + "static/wave21-3151e64a7f13096488fdf673d2ee13b6.png";